import { Grid } from "@mui/material";

import { Participant } from "../../interfaces/interfaces";
import React from "react";
import RenderGridElement from "./renderGridElement";
import transformDateToDe from "../../../../functions/transformDateToDe";

const ListTileUserData = ({
  participant,
}: {
  participant: Participant;
}): React.JSX.Element => {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        my: 1,
      }}
    >
      <Grid item xs={12} md={6} xl={4} sx={{ wordWrap: "break-word" }}>
        <RenderGridElement label="Email" value={participant.email} />
      </Grid>

      <Grid item xs={12} md={6} xl={4} sx={{ wordWrap: "break-word" }}>
        <RenderGridElement label="Telefon" value={participant.phoneNumber} />
      </Grid>

      <Grid item xs={12} md={6} xl={4} sx={{ wordWrap: "break-word" }}>
        <RenderGridElement label="Ort" value={participant.location} />
      </Grid>

      <Grid item xs={12} md={6} xl={4} sx={{ wordWrap: "break-word" }}>
        <RenderGridElement
          label="Qualifikation"
          value={participant.qualification}
        />
      </Grid>

      <Grid item xs={12} md={6} xl={4} sx={{ wordWrap: "break-word" }}>
        <RenderGridElement
          label="Beginn"
          value={transformDateToDe(participant.startOfQualification)}
        />
      </Grid>

      <Grid item xs={12} md={6} xl={4} sx={{ wordWrap: "break-word" }}>
        <RenderGridElement
          label="Ende"
          value={transformDateToDe(participant.endOfQualification)}
        />
      </Grid>

      {participant.coachBindingReleased && (
        <Grid item xs={12} md={6} xl={4} sx={{ wordWrap: "break-word" }}>
          <RenderGridElement label="Coachbindung" value="aufgehoben" />
        </Grid>
      )}
    </Grid>
  );
};

export default ListTileUserData;
